import React from 'react';
import styles from './accountTrigger.module.scss';
import useTranslation from 'next-translate/useTranslation';

export default function AccountTrigger(): JSX.Element {
  const { t } = useTranslation('application');
  const defaultProfile = 'https://f.wishabi.net/creative/Distribution/images/icons/account-outline-default5.svg';

  return (
    <div style={{ display: 'flex' }}>
      <button className={styles.authenticate}>
        <div style={{ display: 'flex' }}>
          <img src={defaultProfile} height="20px" alt="" />
          <span>{t('signin')}</span>
        </div>
      </button>
    </div>
  );
}
